export default null;

export const DATA_TYPE = {
	ORIGIN: 'origin',
	TEMP: 'temp',
};
